
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import Terms from '@pages/terms-and-cond/Index';
import { NextSeo } from 'next-seo';

export default function Index() {
  return (
    <div>
      <NextSeo
        title="247 Radio Carz FAQs."
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/terms-and-conditions',
        }}
        canonical="https://www.247radiocarz.co.uk/terms-and-conditions"
      />
      <Terms />
    </div>
  );
}
